import '../gsmlg-dev';

describe('test logo-gsmlg-dev', () => {
  it('Expect custom element <logo-gsmlg-dev /> is defined', () => {
    const el = customElements.get('logo-gsmlg-dev');
    expect(el).toBeDefined();
  });
});
